export default __webpack_public_path__ + "static/media/terms-and-conditions-header.aa49b150.png";